module.exports = __webpack_public_path__ + "img/logo.d2672c3b.png";